import type { I18nKey } from 'types/i18n'

import * as routeNames from './nombres'
import { buildBreadcrumb } from '@/@core/utils/router'
import { permissionTree, RESOURCE_MANTENIMIENTO } from '@/auth/permissions/modules/mantenimientoMaquinariaPg'
import { defineRoutes } from '@/utils/router'

const { transacciones, dashboard, informes, mantenimiento } = permissionTree

//#region helpers
const breadcrumbMantenimiento = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.mantenimiento', option)
const breadcrumbTransaccion = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.transaccion', option)

const breadcrumbDashboard = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.dashboard', option)

const breadcrumbInformes = (option: I18nKey) =>
    buildBreadcrumb('a:activo_fijo_pg.menu_title', 'a:global.menu.informes', option)
//#endregion

export default defineRoutes([
    {
        path: '/mantenimiento-pg/mantenimiento/gestion-modelo',
        name: routeNames.ROUTE_MANTENIMIENTO_GESTION_MODELO,
        component: () => import('@pages/mantenimiento-pg/mantenimiento/GestionModelo.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_modelo',
            resource: RESOURCE_MANTENIMIENTO,
            action: mantenimiento.gestionModelo,
            breadcrumbs: breadcrumbMantenimiento('manprog.subopcionnes.gestion_modelo'),
        },
    },
    {
        path: '/mantenimiento-pg/mantenimiento/crear-maquinaria',
        name: routeNames.ROUTE_MANTENIMIENTO_GESTION_MAQUINARIA,
        component: () => import('@pages/mantenimiento-pg/mantenimiento/GestionMaquina.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_maquinaria',
            resource: RESOURCE_MANTENIMIENTO,
            action: mantenimiento.crearMaquinaria,
            breadcrumbs: breadcrumbMantenimiento('manprog.subopciones.gestion_maquinaria'),
        },
    },
    {
        path: '/mantenimiento-pg/mantenimiento/gestion-areas',
        name: routeNames.ROUTE_MANTENIMIENTO_GESTION_AREAS_MANPROG,
        component: () => import('@pages/mantenimiento-pg/mantenimiento/GestionAreas.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_area',
            resource: RESOURCE_MANTENIMIENTO,
            action: mantenimiento.area,
            breadcrumbs: breadcrumbMantenimiento('manprog.subopciones.gestion_area'),
        },
    },
    {
        path: '/mantenimiento-pg/mantenimiento/gestion-estrategia',
        name: routeNames.ROUTE_MANTENIMIENTO_GESTION_ESTRATEGIA,
        component: () => import('@pages/mantenimiento-pg/mantenimiento/GestionEstrategia.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_estrategias',
            resource: RESOURCE_MANTENIMIENTO,
            action: mantenimiento.gestionEstrategia,
            breadcrumbs: breadcrumbMantenimiento('manprog.subopciones.gestion_estrategias'),
        },
    },
    {
        path: '/mantenimiento-pg/mantenimiento/gestion-procesos',
        name: routeNames.ROUTE_MANTENIMIENTO_PROCESOS,
        component: () => import('@pages/mantenimiento-pg/mantenimiento/GestionProcesos.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_procesos',
            resource: RESOURCE_MANTENIMIENTO,
            action: mantenimiento.procesos,
            breadcrumbs: breadcrumbMantenimiento('manprog.subopciones.gestion_procesos'),
        },
    },
    {
        path: '/mantenimiento-pg/mantenimiento/gestion-plan-mantenimiento',
        name: routeNames.ROUTE_MANTENIMIENTO_GESTION_PLAN_MANTENIMIENTO,
        component: () => import('@pages/mantenimiento-pg/mantenimiento/GestionPlanMantenimiento.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_plan_mantenimiento',
            resource: RESOURCE_MANTENIMIENTO,
            action: mantenimiento.gestionPlanMantenimiento,
            breadcrumbs: breadcrumbMantenimiento('manprog.subopciones.gestion_plan_mantenimiento'),
        },
    },

    // Transacciones
    {
        path: '/mantenimiento-pg/transacciones/parametrizacion-planes-mantenimiento',
        name: routeNames.ROUTE_PARAMETRIZACION_PLANES_MANTENIMIENTO,
        component: () => import('@pages/mantenimiento-pg/transacciones/ParametrizacionPlanesMantenimiento.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.parametrizacion_planes_mantenimiento',
            resource: RESOURCE_MANTENIMIENTO,
            action: transacciones.parametrizacionPlanesMantenimiento,
            breadcrumbs: breadcrumbTransaccion('manprog.subopciones.parametrizacion_planes_mantenimiento'),
        },
    },
    {
        path: '/mantenimiento-pg/transacciones/crear-orden-trabajo',
        name: routeNames.ROUTE_CREAR_ORDEN_TRABAJO,
        component: () => import('@pages/mantenimiento-pg/transacciones/CrearOrdenTrabajo.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.crear_orden_trabajo',
            resource: RESOURCE_MANTENIMIENTO,
            action: transacciones.crearOrdenTrabajo,
            breadcrumbs: breadcrumbTransaccion('manprog.subopciones.crear_orden_trabajo'),
        },
    },
    {
        path: '/mantenimiento-pg/transacciones/orden-trabajo/:num_orden_trabajo',
        name: routeNames.ROUTE_ORDEN_TRABAJO,
        component: () => import('@pages/mantenimiento-pg/transacciones/CrearOrdenTrabajo.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.orden_trabajo',
            resource: RESOURCE_MANTENIMIENTO,
            action: transacciones.crearOrdenTrabajo,
            breadcrumbs: breadcrumbTransaccion('manprog.subopciones.orden_trabajo'),
        },
    },
    {
        path: '/mantenimiento-pg/transacciones/gestion-orden-trabajo',
        name: routeNames.ROUTE_GESTION_ORDEN_TRABAJO,
        component: () => import('@pages/mantenimiento-pg/transacciones/GestionOrdenTrabajo.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.gestion_orden_trabajo',
            resource: RESOURCE_MANTENIMIENTO,
            action: transacciones.gestionOrdenTrabajo,
            breadcrumbs: breadcrumbTransaccion('manprog.subopciones.gestion_orden_trabajo'),
        },
    },
    // Dashboard
    {
        path: '/mantenimiento-pg/dashboard/maquinaria',
        name: routeNames.ROUTE_DASHBOARD_MAQUINARIA,
        component: () => import('@pages/mantenimiento-pg/dashboard/DashboardMaquinaria.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.dashboard_maquinas',
            resource: RESOURCE_MANTENIMIENTO,
            action: dashboard.maquinas,
            breadcrumbs: breadcrumbDashboard('manprog.subopciones.dashboard_maquinas'),
        },
    },
    {
        path: '/mantenimiento-pg/dashboard/orden-trabajo',
        name: routeNames.ROUTE_DASHBOARD_ORDEN_TRABAJO,
        component: () => import('@pages/mantenimiento-pg/dashboard/DashboardOrdenTrabajo.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.dashboard_ot',
            resource: RESOURCE_MANTENIMIENTO,
            action: dashboard.ordenesTrabajo,
            breadcrumbs: breadcrumbDashboard('manprog.subopciones.dashboard_ot'),
        },
    },
    {
        path: '/mantenimiento-pg/dashboard/por-mantenimiento',
        name: routeNames.ROUTE_DASHBOARD_POR_MANTENIMIENTO,
        component: () => import('@pages/mantenimiento-pg/dashboard/DashboardTipoMantenimiento.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.dashboard_por_mantenimiento',
            resource: RESOURCE_MANTENIMIENTO,
            action: dashboard.porMantenimiento,
            breadcrumbs: breadcrumbDashboard('manprog.subopciones.dashboard_por_mantenimiento'),
        },
    },
    // informes
    {
        path: '/mantenimiento-pg/informes/por-mantenimiento',
        name: routeNames.ROUTE_INFORMES_LISTADO_ORDEN_TRABAJO,
        component: () => import('@pages/mantenimiento-pg/informes/ReporteTipoMantenimiento.vue'),
        meta: {
            title: 'i18n:manprog.subopciones.listado_orden_trabajo',
            resource: RESOURCE_MANTENIMIENTO,
            action: informes.listadoOrdenTrabajos,
            breadcrumbs: breadcrumbInformes('manprog.subopciones.listado_orden_trabajo'),
        },
    },
])
